import {combineReducers} from "redux"

export function loading(state = false, action) {
    switch (action.type) {
        case "SECTOR_DELETE_LOADING":
            return action.loading;

        default:
            return state;
    }
}

export function error(state = false, action) {
    switch (action.type) {
        case "SECTOR_DELETE_ERROR":
            return action.error;

        default:
            return state;
    }
}

export function deleted(state = null, action) {
    switch (action.type) {
        case "SECTOR_DELETE_SUCCESS":
            return action.deleted;

        default:
            return state;
    }
}

export default combineReducers({loading, error, deleted});
